import { Component } from '@angular/core';

@Component({
  selector: 'app-p-events',
  templateUrl: './p-events.component.html',
  styleUrls: ['./p-events.component.scss']
})
export class PEventsComponent {

}
